import { Component, input } from '@angular/core';

@Component({
  selector: 'joii-notification',
  template: `<ng-content />`,
  styleUrl: './notification.component.css',
  host: {
    '[attr.data-type]': 'type()',
  },
})
export class NotificationComponent {
  type = input<string>('info');
}
